import React from "react"
import { Row, Col, Container } from "react-bootstrap"
import MedicalCard from "../../images/medical-card-img.png"
import Phone from "../../images/phone-icon.svg"
import Location from "../../images/location-icon.svg"
import Arrow from "../../images/long-arrow-right.svg"
import Star from "../../images/star-img.png"
import { useMediaQuery } from "react-responsive"

const Therapist = () => {
  let isMobile = useMediaQuery({ query: "(max-device-width: 576px)" })
  return (
    <section id="therapist">
      <Container>
        <Row>
          <Col md={6}>
            <div className="title-txt">FIND THE BEST REHAB CENTER FOR YOU</div>
            <h1>Find The Right Therapist</h1>
            {isMobile ? (
              <></>
            ) : (
              <button className="find-help-btn btn">
                All Therapists
                <span className="pl-3">
                  <img src={Arrow} alt="" />
                </span>
              </button>
            )}
          </Col>
          <Col md={6} className="mt-5">
            <p>
              Rehab Find is a unique online rehab facility finder. With our
              database of specialists and addiction rehab providers, you can get
              connected with the rehab centre that suits your needs. Are you
              looking for in-person care from a specialist? Do you want to be an
              in-patient at the best rehab centre for you? By using our most
              comprehensive database of rehab centers online, we can help you
              quickly find the perfect specialist or center to fit your unique
              needs. Search below to get started.
            </p>
          </Col>
        </Row>
        {isMobile?(<button className="find-help-btn btn" style={{marginBottom:"1rem"}}>
          All Therapists
          <span className="pl-3">
            <img src={Arrow} alt="" />
          </span>
        </button>):(<></>)}
        
        <Row>
          <Col md={4} className="card-section">
            <div className="medical-card">
              <div className="card-head d-flex">
                <div className="head-img">
                  <img src={MedicalCard} alt="" className="w-60" />
                  <img
                    src={Star}
                    alt=""
                    className="w-75 mx-auto d-block mt-2"
                  />
                </div>

                <div className="head-txt">
                  <h3>Nick Porter</h3>
                  <div className="designation">
                    Registered Psychologist, BSc, M.Ed, Ed.D
                  </div>
                  <div className="paractice-year">Practicing: 21 years</div>
                </div>
              </div>
              <hr />
              <p>
                <span className="pr-2">
                  <img src={Location} alt="" />
                </span>
                36 Miller Stile Rd Quincy, MA
              </p>
              <p>
                <span className="pr-2">
                  <img src={Phone} alt="" />
                </span>
                855-401-72220
              </p>
            </div>
          </Col>
          <Col md={4} className="card-section">
            <div className="medical-card">
              <div className="card-head d-flex">
                <div className="head-img">
                  <img src={MedicalCard} alt="" className="w-60" />
                  <img
                    src={Star}
                    alt=""
                    className="w-75 mx-auto d-block mt-2"
                  />
                </div>

                <div className="head-txt">
                  <h3>Nick Porter</h3>
                  <div className="designation">
                    Registered Psychologist, BSc, M.Ed, Ed.D
                  </div>
                  <div className="paractice-year">Practicing: 21 years</div>
                </div>
              </div>
              <hr />
              <p>
                <span className="pr-2">
                  <img src={Location} alt="" />
                </span>
                36 Miller Stile Rd Quincy, MA
              </p>
              <p>
                <span className="pr-2">
                  <img src={Phone} alt="" />
                </span>
                855-401-72220
              </p>
            </div>
          </Col>
          <Col md={4} className="card-section">
            <div className="medical-card">
              <div className="card-head d-flex">
                <div className="head-img">
                  <img src={MedicalCard} alt="" className="w-60" />
                  <img
                    src={Star}
                    alt=""
                    className="w-75 mx-auto d-block mt-2"
                  />
                </div>

                <div className="head-txt">
                  <h3>Nick Porter</h3>
                  <div className="designation">
                    Registered Psychologist, BSc, M.Ed, Ed.D
                  </div>
                  <div className="paractice-year">Practicing: 21 years</div>
                </div>
              </div>
              <hr />
              <p>
                <span className="pr-2">
                  <img src={Location} alt="" />
                </span>
                36 Miller Stile Rd Quincy, MA
              </p>
              <p>
                <span className="pr-2">
                  <img src={Phone} alt="" />
                </span>
                855-401-72220
              </p>
            </div>
          </Col>
          <Col md={4} className="card-section">
            <div className="medical-card">
              <div className="card-head d-flex">
                <div className="head-img">
                  <img src={MedicalCard} alt="" className="w-60" />
                  <img
                    src={Star}
                    alt=""
                    className="w-75 mx-auto d-block mt-2"
                  />
                </div>

                <div className="head-txt">
                  <h3>Nick Porter</h3>
                  <div className="designation">
                    Registered Psychologist, BSc, M.Ed, Ed.D
                  </div>
                  <div className="paractice-year">Practicing: 21 years</div>
                </div>
              </div>
              <hr />
              <p>
                <span className="pr-2">
                  <img src={Location} alt="" />
                </span>
                36 Miller Stile Rd Quincy, MA
              </p>
              <p>
                <span className="pr-2">
                  <img src={Phone} alt="" />
                </span>
                855-401-72220
              </p>
            </div>
          </Col>
          <Col md={4} className="card-section">
            <div className="medical-card">
              <div className="card-head d-flex">
                <div className="head-img">
                  <img src={MedicalCard} alt="" className="w-60" />
                  <img
                    src={Star}
                    alt=""
                    className="w-75 mx-auto d-block mt-2"
                  />
                </div>

                <div className="head-txt">
                  <h3>Nick Porter</h3>
                  <div className="designation">
                    Registered Psychologist, BSc, M.Ed, Ed.D
                  </div>
                  <div className="paractice-year">Practicing: 21 years</div>
                </div>
              </div>
              <hr />
              <p>
                <span className="pr-2">
                  <img src={Location} alt="" />
                </span>
                36 Miller Stile Rd Quincy, MA
              </p>
              <p>
                <span className="pr-2">
                  <img src={Phone} alt="" />
                </span>
                855-401-72220
              </p>
            </div>
          </Col>
          <Col md={4} className="card-section">
            <div className="medical-card">
              <div className="card-head d-flex">
                <div className="head-img">
                  <img src={MedicalCard} alt="" className="w-60" />
                  <img
                    src={Star}
                    alt=""
                    className="w-75 mx-auto d-block mt-2"
                  />
                </div>

                <div className="head-txt">
                  <h3>Nick Porter</h3>
                  <div className="designation">
                    Registered Psychologist, BSc, M.Ed, Ed.D
                  </div>
                  <div className="paractice-year">Practicing: 21 years</div>
                </div>
              </div>
              <hr />
              <p>
                <span className="pr-2">
                  <img src={Location} alt="" />
                </span>
                36 Miller Stile Rd Quincy, MA
              </p>
              <p>
                <span className="pr-2">
                  <img src={Phone} alt="" />
                </span>
                855-401-72220
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Therapist
